<script>
    import { timeAgo } from "../../helpers";
    import { TextInput, Dropdown } from "carbon-components-svelte";
    import Delete from "carbon-icons-svelte/lib/Delete.svelte";
    import Add from "carbon-icons-svelte/lib/Add.svelte";
    import { createEventDispatcher } from 'svelte';
    
    const dispatch = createEventDispatcher();

	export let prices = [];

    function setNewRow() {
        return { 
            quantity: "", 
            price: "", 
            unit: "tonnes", 
            last_updated: new Date().toISOString()
        };
    }

	function addRow() {
        newRow = setNewRow();
        prices = [...prices, newRow];
        dispatch('price-updated', prices);
	}
    
	function deleteRow(rowToBeDeleted) {
        prices = prices.filter(price => price !== rowToBeDeleted);
        newRow = setNewRow();
        dispatch('price-updated', prices);
	}

    function isInvalidQuantity(value) {
        if (value === undefined || value === null || value === "") return false;
        return isNaN(value);
    }

    function isInvalidPrice(value) {
        if (value === undefined || value === null || value === "") return false;
        if (typeof value === 'string' && value.trim().toLowerCase() === 'free') return false;
        return isNaN(value);
    }

    function handlePriceFieldChange(price) {
        price.last_updated = new Date().toISOString();
        prices = [...prices];
        dispatch('price-updated', prices);
    }

    function getSelectedUnitId(unit) {
        if (!unit) return "0";
        const u = String(unit).toLowerCase().trim();
        if (u === 'load' || u === 'bin') return "1";
        if (u === 'cubes' || u === 'cube') return "2";
        return "0"; // 'tonnes' or legacy 'tonne'
    }

	let newRow = setNewRow();
</script>

<div class="prices-tier-list">
    {#if prices && prices.length > 0}
        <div class="price-tier-header">
            <span>Max Qty</span>
            <span>Price ($)</span>
            <span>Unit</span>
            <span class="center">Updated</span>
            <span></span>
        </div>
    {/if}
    {#each prices as price}
        <div class="price-tier-row">
            <div class="tier-field qty">
                <TextInput 
                    hideLabel 
                    size="sm" 
                    labelText="Quantity" 
                    placeholder="Qty" 
                    bind:value={price.quantity} 
                    invalid={isInvalidQuantity(price.quantity)} 
                    on:input={() => handlePriceFieldChange(price)}
                /> 
            </div>
            <div class="tier-field price">
                <TextInput 
                    hideLabel 
                    size="sm" 
                    labelText="Price" 
                    placeholder="$ Price or free" 
                    bind:value={price.price} 
                    invalid={isInvalidPrice(price.price)} 
                    on:input={() => handlePriceFieldChange(price)}
                />
            </div>
            <div class="tier-field unit">
                <Dropdown
                    hideLabel
                    size="sm"
                    selectedId={getSelectedUnitId(price.unit)}
                    items={[
                        { id: "0", text: "tonnes" },
                        { id: "1", text: "load" },
                        { id: "2", text: "cubes" },
                    ]}
                    on:select={(e) => {
                        price.unit = e.detail.selectedItem.text;
                        handlePriceFieldChange(price);
                    }}
                />
            </div>
            <div class="tier-time-ago" title={price.last_updated}>
                {timeAgo(price.last_updated)}
            </div>
            <button class="tier-delete-btn" on:click={() => deleteRow(price)} title="Remove Price Tier" type="button">
                <Delete size={16} />
            </button>
        </div>
    {/each}

    <button class="add-tier-btn" on:click={addRow} type="button">
        <Add size={14} />
        <span>Add Price Tier</span>
    </button>
</div>

<style>
    .prices-tier-list {
        display: flex;
        flex-direction: column;
        gap: 6px;
        width: 100%;
    }

    .price-tier-header {
        display: grid;
        grid-template-columns: 80px 80px 90px 60px 24px;
        gap: 6px;
        font-size: 10.5px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.03em;
        color: var(--tt-slate-500);
        padding: 0 2px;
    }

    .price-tier-header span.center {
        text-align: center;
    }

    .price-tier-row {
        display: grid;
        grid-template-columns: 80px 80px 90px 60px 24px;
        gap: 6px;
        align-items: center;
        width: 100%;
    }

    .tier-field {
        width: 100%;
    }

    :global(.tier-field .bx--text-input) {
        margin: 0 !important;
        height: 30px !important;
        font-size: 12px !important;
        border-radius: 6px !important;
        border: 1px solid var(--tt-slate-200) !important;
        background-color: #ffffff !important;
    }

    :global(.tier-field .bx--text-input:focus) {
        border-color: var(--tt-primary) !important;
        box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.15) !important;
    }

    :global(.tier-field .bx--dropdown) {
        height: 30px !important;
    }

    :global(.tier-field .bx--list-box__field) {
        height: 30px !important;
        padding: 0 8px !important;
        border-radius: 6px !important;
        border: 1px solid var(--tt-slate-200) !important;
        background-color: #ffffff !important;
    }

    :global(.tier-field .bx--list-box__label) {
        font-size: 11.5px !important;
        line-height: 28px !important;
    }

    .tier-time-ago {
        font-size: 10px;
        color: var(--tt-slate-400);
        font-style: italic;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .tier-delete-btn {
        background: transparent;
        border: none;
        color: var(--tt-slate-400);
        cursor: pointer;
        padding: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: all 0.15s ease;
    }

    .tier-delete-btn:hover {
        color: var(--tt-danger);
        background-color: var(--tt-danger-bg);
    }

    .add-tier-btn {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        background: transparent;
        border: 1px dashed var(--tt-slate-300);
        border-radius: 9999px;
        padding: 4px 10px;
        font-size: 11px;
        font-weight: 600;
        color: var(--tt-slate-600);
        cursor: pointer;
        margin-top: 4px;
        align-self: flex-start;
        transition: all 0.15s ease;
    }

    .add-tier-btn:hover {
        border-color: var(--tt-primary);
        color: var(--tt-primary);
        background-color: rgba(66, 133, 244, 0.08);
    }
</style>